import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as routerActions from 'react-router-redux'
import { modifyProps } from 'lp-hoc'
import { ContentBlock, FormBlock } from 'components'
import { ResetPasswordForm } from '../forms'
import * as apiActions from 'api-actions'
import { SCHOOL_PORTAL_ROUTE } from 'config'
import { displaySubmitFailure } from 'utils'

const propTypes = {
  push: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired,
}

const defaultProps = {}

function ClaimAccountPassword({ resetPassword, push }) {
  return (
    <ContentBlock>
      <FormBlock>
        <div className="form-block-inner">
          <h2>One more step</h2>
          <p>
            {' '}
            Enter a password for your account. Once your password is created,
            you will be prompted to sign in on the next page.{' '}
          </p>
          <ResetPasswordForm
            onSubmit={resetPassword}
            onSubmitSuccess={() => {
              return push(SCHOOL_PORTAL_ROUTE)
            }}
            onSubmitFail={displaySubmitFailure}
          />
        </div>
      </FormBlock>
    </ContentBlock>
  )
}

ClaimAccountPassword.propTypes = propTypes
ClaimAccountPassword.defaultProps = defaultProps

const mapDispatchToProps = {
  push: routerActions.push,
  resetPassword: apiActions.resetPassword,
}

function modify({ params: { token }, resetPassword }) {
  return {
    resetPassword: ({ password }) => resetPassword({ password, token }),
  }
}

export default compose(
  connect(null, mapDispatchToProps),
  modifyProps(modify)
)(ClaimAccountPassword)
